import { useMemo, useState } from "react";
import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";
import { useCommunicationBinding } from "./useCommunicationBinding";
import { PhoneNumberBinding } from "./PhoneNumberBinding/PhoneNumberBinding";
import useMcubeEngageConfiguration from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageConfiguration";

function WhatsAppCommunicationBinding(props) {
  const {
    communicationBinding,
    syncAssistant,
    workspaceId,
    assistantId,
    assistantType,
    locked,
  } = props;
  const { addCommunicationBinding, removeCommunicationBinding } =
    useCommunicationBinding({
      syncAssistant,
      assistantId,
      workspaceId,
      assistantType,
    });
  const [openDelete, setOpenDelete] = useState({
    item: null,
    isOpen: false,
  });
  const { whatsappConfiguration } = useWhatsappConfiguration(workspaceId);
  const {
    mcubeEngageConfiguration,
    isLoading: isMCubeEngageConfigurationLoading,
    isConfigured: isMCubeEngageConfigured,
  } = useMcubeEngageConfiguration(workspaceId);

  const handleBindingDelete = () => {
    removeCommunicationBinding(openDelete.item._id).then(() => {
      setOpenDelete({ item: null, isOpen: false });
    });
  };

  const { phoneNumbers, phoneNumbersProviderMap } = useMemo(() => {
    if (whatsappConfiguration.loading || isMCubeEngageConfigurationLoading) {
      return { phoneNumbers: [], phoneNumbersProviderMap: {} };
    }

    const whatsappPhoneNumberIds = whatsappConfiguration.isConfigured
      ? whatsappConfiguration.data.phoneNumberIds
      : [];
    const mCubeEngagePhoneNumbers = isMCubeEngageConfigured
      ? mcubeEngageConfiguration?.phoneNumbers
      : [];

    const phoneNumberProvidersRegistry = {
      meta: whatsappPhoneNumberIds,
      mcubeEngage: mCubeEngagePhoneNumbers,
    };

    const providers = Object.keys(phoneNumberProvidersRegistry);

    const phoneNumbersProviderMap = providers.reduce(function (acc, provider) {
      const providerNumbers = phoneNumberProvidersRegistry[provider];

      return providerNumbers.reduce(function (acc, number) {
        return {
          ...acc,
          [number]: provider,
        };
      }, acc);
    }, {});

    return {
      phoneNumbers: [...whatsappPhoneNumberIds, ...mCubeEngagePhoneNumbers],
      phoneNumbersProviderMap,
    };
  }, [whatsappConfiguration, mcubeEngageConfiguration]);

  const handleBindingAdd = (data, closeDialog) => {
    const provider = phoneNumbersProviderMap[data.identifier];

    const payload = {
      channelType: assistantType,
      isActive: true,
      ...data,
      metadata: {
        provider,
      },
    };

    addCommunicationBinding(payload).then(closeDialog);
  };

  return (
    <PhoneNumberBinding
      isOpen={openDelete.isOpen}
      onClose={() => setOpenDelete({ isOpen: false, item: null })}
      onBindingDelete={(item) => setOpenDelete({ isOpen: true, item })}
      onBindingAdd={handleBindingAdd}
      onBindingConfirmDelete={handleBindingDelete}
      phoneNumbers={phoneNumbers}
      communicationBinding={communicationBinding}
      locked={locked}
    />
  );
}

export { WhatsAppCommunicationBinding };
